
/**
 * フロアマップチェンジ
 */
!function(){
	var $btn = $('.js-floor-map-change_btn');
	var $wrap = $('.js-floor-map-change_wrap');
	var $item = $('.js-floor-map-change_item');
	if(!($btn.length !== 0 && $wrap.length !== 0 && $item.length !== 0)) return false;
	var startId = $wrap.attr('data-now-id');
	$('.js-floor-map-change_btn[data-target="'+startId+'"]').addClass('_active');
	$btn.click(function(){
		var targetEle = $(this).attr('data-target');
		var $target = $(targetEle);
		if($target.length === 0) return false;
		var nowFloor = $target.attr('data-floor');
		$item.each(function(){
			if($(this).is(':visible')){
				$(this).fadeOut('normal',function(){
					$target.fadeIn();
					$btn.removeClass('_active');
					$('.js-floor-map-change_btn[data-target="'+targetEle+'"]').addClass('_active');
					$wrap.attr({
						'data-now-floor':nowFloor,
						'data-now-id':targetEle,
					});
				});
			};
		});
		return false;
	});
}();